import React, { useState,useEffect } from 'react';
import { saveAs } from 'file-saver';

const DownloadComponent = ({ fileUrl, fileName, onClose}) => {

  console.log("fileUrl",fileUrl)
  const handleDownload = () => {
    saveAs(fileUrl, fileName);
  };
  useEffect(() => {
    saveAs(fileUrl, fileName);
    onClose();
}, []);

  return (
    <p>Downloading....</p>
  );
};

export default DownloadComponent;